import { Box, Typography } from "@mui/material";
import { CustomTable, DateTimeDisplay } from "components";
import moment from "moment-timezone";

const ContractActivityForm = ({
  dataTable,
  queryParams,
  tableTotalPage,
  handleChangeQueryParams,
  isLoading,
}) => {
  return (
    <CustomTable
      isLoading={isLoading}
      columnTable={columnTable}
      data={dataTable}
      page={Number(queryParams?.page)}
      pageSize={Number(queryParams?.size)}
      pageCount={tableTotalPage}
      handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
      handleChangePageSize={e =>
        handleChangeQueryParams(e?.target?.value, "size")
      }
    />
  );
};

const columnTable = [
  {
    name: "all",
    title: "Date & Time",
    renderText: item => (
      <DateTimeDisplay date={moment(`${item?.date} ${item?.time}`)} />
    ),
  },
  {
    name: "all",
    title: "Account",
    renderText: item => (
      <Box>
        {item?.created_by_name}
        <Typography fontSize={12} color="#687083">
          {item?.created_by_email}
        </Typography>
      </Box>
    ),
  },
  {
    name: "action",
    title: "Action",
  },
  {
    name: "slug_action",
    title: "Information",
  },
];

export default ContractActivityForm;
